module.exports = new __parcel__URL__("kaiju_kingmaker_level_1.59d7d408.png").toString();